import rscBridge from '@/utils/rscBridge'
const state = {
  rscBridgeObj: null
}

const getters = {
  rscBridgeObj: state => state.rscBridgeObj
}

const actions = {
  // 获取用户信息
  async GetNativeObject ({commit, state}) {
    console.log('进入action方法')
    rscBridge.callback = await function (appRscB) {
      console.log('得到数据appRscB--->', appRscB)
      commit('GETNATIVEOBJ', appRscB)
    }
  }
}

const mutations = {
  GETNATIVEOBJ (state, status) {
    state.rscBridgeObj = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/NativeAbout.js